import React, { useContext } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem('theme')

  // language 
  const translations = {
    hi: {
      contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
      money: 'राशि डालें  ',
      next: 'आगे बड़े ',
      addAmount: 'राशि जोड़ी जानी है ',
      referPerson: 'रेफ़रल | ',
    },
    en: {
      contact: 'Contact Us At Below Platforms.',
      money: 'Enter Amount',
      next: 'Next',
      addAmount: 'Amount to be added',
      referPerson: 'Referral',
    },
  };

  const { language } = useContext(LanguageContext);


  // change theme 
  const styles = {
    backgroundColor: theme === 'light' ? '#E8FFF4' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };
  const styles1 = {
    color: theme === 'light' ? 'black' : 'white',
  };

  return (
    <div className="leftContainer"
          style={{ ...styles, minHeight: "100vh", height: "100%" }}>
      <div class="cyberpunk-support-system">

  <div class="cyber-header-panel">

    <div class="cyber-grid"></div>

    <div class="cyber-header-content">     

      <div class="support-live-stats">

        <div class="live-stat-box">
          <h2>24/7</h2>
          <span>ACTIVE SUPPORT</span>
        </div>

        <div class="live-stat-box">
          <h2>99%</h2>
          <span>FAST RESPONSE</span>
        </div>

        <div class="live-stat-box">
          <h2>5000+</h2>
          <span>PLAYERS HELPED</span>
        </div>

      </div>

    </div>

    <div class="cyber-support-image">

      <img
        src="./images/support.jpg"
        alt=""
      />

      <div class="image-glow"></div>

    </div>

  </div>

  <div class="cyber-support-grid">

     <a
      class="cyber-support-card whatsapp-cyber"
      href="#"
      target="_blank"
    >

      <div class="cyber-card-line"></div>

      
       <div class="cyber-icon-wrap">
        <img
          src="/images/Call ringing animation.gif"
          alt=""
        />
        <small>Call SUPPORT</small>
      </div>
      <div class="cyber-btn">
        CALL NOW
      </div>

    </a>
    <a  class="cyber-support-card whatsapp-cyber"   href="#"   target="_blank"  >
      <div class="cyber-card-line"></div>     
       
      <div class="cyber-icon-wrap">
        <img
          src="/images/whatsapp-new-.png"
          alt=""
        />
        <h3>WhatsApp Support</h3>
      </div>     

      <div class="cyber-btn">
        CONNECT
      </div>

    </a>

    <a
      class="cyber-support-card email-cyber"
      href="#"
    >

      <div class="cyber-card-line"></div>

      <div class="cyber-icon-wrap">
        <img
          src="./images/mail-new.png"
          alt=""
        />
        <h3>Email Support</h3>
      </div>

      

      <div class="cyber-btn">
        SEND MAIL
      </div>

    </a>

    <a
      class="cyber-support-card telegram-cyber"
      href="#"
    >

      <div class="cyber-card-line"></div>

      <div class="cyber-icon-wrap">
        <img
          src="./images/telegram.png"
          alt=""
        />
        <h3>Telegram Support</h3>
      </div>

      

      <div class="cyber-btn">
        JOIN NOW
      </div>

    </a>

   

  </div>

  

</div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
